import { HttpClient } from './serviceBase';
import { utils } from '../utils/utils';

class CartService {
    MapCustomer = (customer) => {
        if (!customer)
            return null;

        if (customer.address?.isInvoice)
            return customer;

        const address = customer.addresses
            ? customer.addresses.find(p => p.isInvoice)
            : null

        return {
            ...customer,
            address
        }
    }

    MapOrderToCart = (order) => ({
        orderId: order.orderId,
        customer: this.MapCustomer(order.customer),
        sellerCode: order.sellerCode,
        products: order.items,
        productsToReturn: order.itemsToReturn,
        shippingData: order.shippingData,
        paymentMethodData: order.paymentMethodData,
        additionalPromotions: order.additionalPromotions,
        invoiceType: order.invoiceType,
        perceptions: order.perceptions,
        ignoredPromotionIds: order.ignoredPromotionIds || [],
        observations: order.observations,
        priceListId: order.priceListId
    })

    Get = async (orderId) => {
        const mapSale = (shoppingCart) => ({
            ...shoppingCart,
            totalPayedAmount: utils.mapTotalPayedAmount(shoppingCart),
            paymentMethodData: utils.mapPayment(shoppingCart),
            returnMode:false
        })

        const res = await HttpClient.Get(`/api/cart/${orderId}`);
        return mapSale(res);
    }

    Update = async (item) =>
        await HttpClient.Put(`/api/cart/${item.orderId}`, this.MapOrderToCart(item));

    InitiatePayment = async ( req ) =>
        await HttpClient.Post(`/api/cart/${req.orderId}/initiate-payment`, req);

    UpdatePerception = async (orderId, calculatedPerception) =>
        await HttpClient.Put(`/api/cart/${orderId}/perception`, calculatedPerception);
}

export default new CartService();